import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  generateOtp,
  generateToken,
  validateOtp,
} from "../../redux/slice/sendOtp";
import "./login.scss";
import Layout from "../../component/layout/Layout";
import { AppContext } from "../../utils/context";
import Spinner from "../../component/spinner/Spinner";
import { toast } from "react-toastify";
import {
  getOtpErrorMessage,
  isOtpGenerateSuccess,
} from "../../utils/otpErrors";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { generateOtpObj, generateTokenObj } = useSelector(
    (state) => state.otpGenerateData
  );

  const { mobile, setMobile } = useContext(AppContext);
  //   const [mobile, setMobile] = useState("");

  const handleSendOtp = async (mobile,setSubmitting) => {    
    localStorage.setItem("mobile", mobile);
    const data = {
      mobile,
    };

    const output = await dispatch(generateToken(data));
    localStorage.setItem("sessionId", output?.payload?.user?.sessionId);
    let otpOutput;
    if (output?.payload?.status?.success) {
      const otpInputData = {
        mobile,
        sessionId: output?.payload?.user?.sessionId,
      };
      otpOutput = await dispatch(generateOtp(otpInputData));
    }else{
      toast.error(output?.payload?.status?.message);
    }
    if (isOtpGenerateSuccess(otpOutput?.payload)) {
      //   const validateOtpInputData = {
      //     mobile,
      //     sessionId: output?.payload?.user?.sessionId,
      //   };
      //   dispatch(validateOtp(validateOtpInputData));

      navigate("/otp");
    } else {
      toast.error(getOtpErrorMessage(otpOutput?.payload));
      localStorage.clear();
      setSubmitting(false);
    }
  };

  const validationSchema = Yup.object({
    mobile: Yup.string()
      .matches(
        /^[1-9]\d{9}$/,
        "Mobile number must be exactly 10 digits and cannot start with 0"
      )
      .required("Mobile number is required"),
    termsAccepted: Yup.boolean().oneOf(
      [true],
      "You must accept the terms and privacy policy"
    ),
  });

 useEffect(()=>{
  localStorage.clear();
 },[]);

  return (
    <>
      <Layout>
        <div className="mob_h1">
          <h1 className="mobile_content ">Welcome to </h1>
          <h1 className="mobile_content ">DLF Malls Rewards</h1>
        </div>
        <div className="box">
          <div className="inner_center_box">
            <h1 className="desktop_content">Welcome to DLF Malls Rewards</h1>
            <Formik
              initialValues={{
                mobile: "",
                termsAccepted: false,
              }}
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                // handleSendOtp(values.mobile, setSubmitting);
                handleSendOtp(`91${values.mobile}`, setSubmitting);
              }}
            >
              {({ values, errors, touched, setFieldValue, isSubmitting }) => (
                <Form>
                  <div className="form-check_1">
                    <div className="div_center formik-field">
                      <span className="prefix">+91</span>
                      <Field
                        name="mobile"
                        type="text"
                        placeholder="Enter mobile number"
                        className={`form-control mobile ${
                          errors.mobile && touched.mobile ? "error-border" : ""
                        }`}
                        maxLength="10"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, ""); // Removes non-digit characters
                          setMobile("91"+e.target.value);
                          // setMobile(e.target.value);
                        }}                        
                      />
                      <ErrorMessage
                        name="mobile"
                        component="div"
                        className="error-text"
                      />
                    </div>

                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      <Field
                        name="termsAccepted"
                        type="checkbox"
                        id="flexCheckDefault"
                        className="form-check-input"
                      />
                      By Continuing, I agree to <span>
                      <Link to="/terms-and-conditions" className="privacylink">
                      Terms & Conditions
                        </Link>
                        </span> &{" "}
                      <span>
                        <Link to="/privacy" className="privacylink">
                          Privacy <span className="change_display">Policy</span>
                        </Link>
                      </span>
                      <ErrorMessage
                        name="termsAccepted"
                        component="div"
                        className="error-text"
                      />
                    </label>

                    <div>
                      <button
                        type="submit"
                        className={
                          !values.termsAccepted ? "disabled_button" : ""
                        }
                        disabled={
                          isSubmitting ||
                          generateOtpObj?.loading ||
                          generateTokenObj?.loading                          
                        }
                      >
                        Send OTP{" "}
                        {(generateOtpObj?.loading ||
                          generateTokenObj?.loading) && <Spinner />}
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Layout>
    </>
  );
}

export default Login;
